import { FreeWheelPauseAdUtilities } from 'tag/ts/tag/ads/pause/FreeWheelPauseAdUtilities';
import { GAMPauseAdUtilities } from 'tag/ts/tag/ads/pause/GAMPauseAdUtilities';
import { PauseAdType } from 'tag/ts/tag/model/type/ads/PauseAdType';
export class PauseAdService {
    static getPauseAd(tag, type) {
        let pauseAdUtilities;
        switch (type) {
            case PauseAdType.GAM:
                pauseAdUtilities = new GAMPauseAdUtilities({ tag: tag });
                return pauseAdUtilities.makePauseAdCall();
            case PauseAdType.FREEWHEEL:
                pauseAdUtilities = new FreeWheelPauseAdUtilities({ tag: tag });
                return pauseAdUtilities.makePauseAdCall();
            default:
                return new Promise((resolve, reject) => {
                    reject({
                        msg: `PauseAdUtilities creation failed Error type: wrong pauseAd Type: ${type}`,
                        success: false
                    });
                });
        }
    }
}
